import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { Editor } from "@tinymce/tinymce-react";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Alert,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import { FiChevronUp, FiChevronDown, FiEdit3 } from "react-icons/fi";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
function EditModel({
  backUrl,
  api,
  fetchData,
  getType,
  getOrientation,
  getCategory,
  handleSubmit,
  getShow,
  showData,
  getListe,
  // liste
  listeData,

  //render

  renderOuiNonOptions,
  renderOrientationOptions,
  renderTypeOptions,
  renderCategorieOptions,
  //Variable
  //actif
  selectedActif,
  handleActifChange,
  // typeDocument
  selectedType,
  handleTypeChange,
  // Nom modele
  selectedNomMod,
  handleNomModChange,
  // original
  selectedOriginal,
  handleOriginalChange,
  // fisc
  selectedFisc,
  handleFiscChange,
  // Transmission API
  selectedTransmissionAPI,
  handleTransmissionAPIChange,
  //Catégorie PME
  selectedCategorie,
  handleCategorieChange,
  // Balises
  selectedBalise,
  handleBaliseChange,
  // Cumul
  selectedCumul,
  handleCumulChange,
  // Commentaire
  selectedCommentaire,
  handleCommentaireChange,
  //Champs
  selectedChamps1,
  selectedChamps2,
  selectedChamps3,
  selectedChamps4,
  selectedChamps5,
  selectedChamps6,
  handleChamps1Change,
  handleChamps2Change,
  handleChamps3Change,
  handleChamps4Change,
  handleChamps5Change,
  handleChamps6Change,
  // Images
  selectedImage1,
  selectedImage2,
  selectedImage3,
  selectedImage4,

  handleImage1Change,
  handleImage2Change,
  handleImage3Change,
  handleImage4Change,
  //Nom du fichier global
  selectedNomGlobal,
  handleNomGlobalChange,
  //Nom Fichier Individuel
  selectedNomIndividuel,
  handleNomIndividuelChange,
  // Orientation
  selectedOrientation,
  handleOrientationChange,
  // Fichier par occurence
  selectedFichierParOccurence,
  handleFichierParOccurenceChange,
  // Marge Haut
  selectedMargeHaut,
  handleMargeHautChange,
  // Marge Bas
  selectedMargeBas,
  handleMargeBasChange,
  // Marge Cote
  selectedMargeCote,
  handleMargeCoteChange,
  // Hauteur de ligne
  selectedHauteurLigne,
  handleHauteurLigneChange,
  // Hauteur  pied
  selectedHauteurPied,
  handleHauteurPiedChange,
  //Largeur
  selectedLargeur,
  handleLargeurChange,
  //Tableau
  formSignature,
  onAddFormSignature,
  onDeleteFormSignature,
  handleInputChange,
  // variable données
  modelData,
  CaracteristiqueData,
  PresentationData,
  FiltresData,
  ChampsImpressionData,
  ImagesData,
  CommentaireData,
  // COntenu
  selectedContent,
  handleContentChange,
  setContent,
  selectedHeader,
  handleHeaderChange,
  selectedFooter,
  handleFooterChange,

  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  colStyle,
  toggleTooltip,
  tooltipOpen,
  toggleTooltip1,
  tooltipOpen1,
  toggleTooltip2,
  tooltipOpen2,
  toggleTooltip3,
  tooltipOpen3,
  toggleTooltip4,
  tooltipOpen4,
  toggleTooltip5,
  tooltipOpen5,
  toggleTooltip6,
  tooltipOpen6,
  toggleTooltip7,
  tooltipOpen7,
  toggleTooltip8,
  tooltipOpen8,
  toggleTooltip9,
  tooltipOpen9,
  toggleTooltip10,
  tooltipOpen10,
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      handleContentChange(editorRef.current.getContent());
    }
  };
  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, []);

  useEffect(() => {
    if (!loading) {
      getType();
      getOrientation();
      getCategory();
      getListe();
    }
  }, [loading]);
  useEffect(() => {
    getShow();
  }, [selectedType]);
  const layout = localStorage.getItem("layoutMode");
  const styles = makeSelectStyles(layout);
  // État pour le collapse
  const [isCaracteristiquesAccordionOpen, setIsCaracteristiquesAccordionOpen] =
    useState(true);

  // Fonction toggle
  const toggleCaracteristiquesAccordion = () => {
    setIsCaracteristiquesAccordionOpen(!isCaracteristiquesAccordionOpen);
  };
  const [isFiltresCumulAccordionOpen, setIsFiltresCumulAccordionOpen] =
    useState(true);

  const toggleFiltresCumulAccordion = () => {
    setIsFiltresCumulAccordionOpen(!isFiltresCumulAccordionOpen);
  };
  const [isCommentairesAccordionOpen, setIsCommentairesAccordionOpen] =
    useState(true);

  const toggleCommentairesAccordion = () => {
    setIsCommentairesAccordionOpen(!isCommentairesAccordionOpen);
  };
  const [isPresentationAccordionOpen, setIsPresentationAccordionOpen] =
    useState(true);
  const togglePresentationAccordion = () =>
    setIsPresentationAccordionOpen(!isPresentationAccordionOpen);
  const [isChampsImpressionAccordionOpen, setIsChampsImpressionAccordionOpen] =
    useState(true);

  const toggleChampsImpressionAccordion = () => {
    setIsChampsImpressionAccordionOpen(!isChampsImpressionAccordionOpen);
  };
  const [isImagesAccordionOpen, setIsImagesAccordionOpen] = useState(true);

  const toggleImagesAccordion = () => {
    setIsImagesAccordionOpen(!isImagesAccordionOpen);
  };
  const [isContenuAccordionOpen, setIsContenuAccordionOpen] = useState(true);
  const toggleContenuAccordion = () => {
    setIsContenuAccordionOpen(!isContenuAccordionOpen);
  };
  const [isSignatureAccordionOpen, setIsSignatureAccordionOpen] =
    useState(true);
  const toggleSignatureAccordion = () => {
    setIsSignatureAccordionOpen(!isSignatureAccordionOpen);
  };
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Offcanvas
              isOpen={showOffcanvas}
              scrollable
              backdrop={false}
              toggle={handleOffcanvasToggle}
              style={{ width: "35%" }}
            >
              <OffcanvasHeader toggle={handleOffcanvasToggle}>
                Liste des balises
              </OffcanvasHeader>
              <OffcanvasBody>
                <div dangerouslySetInnerHTML={{ __html: listeData }} />
              </OffcanvasBody>
            </Offcanvas>

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Titre
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>
                    <Alert color="warning" isOpen={true}>
                      <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-outline"></i>
                        <span>
                          <strong>
                            Astuce : Pour importer un document Word :
                          </strong>
                          <ul className="mb-0 mt-1">
                            <li>
                              Sauvegardez le au format "Web Page Filtered"
                              (HTML)
                            </li>
                            <li>
                              Ouvrez le avec un éditeur de texte type Bloc Note
                            </li>
                            <li>Copiez le contenu dans le presse papier</li>
                            <li>
                              Collez le dans le modèle Fluxod au format HTML
                              (Bouton HTML dans la barre de menu de l'éditeur)
                            </li>
                          </ul>
                        </span>
                      </div>
                    </Alert>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleCaracteristiquesAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Caractéristiques
                                      </span>
                                    </div>
                                    {isCaracteristiquesAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isCaracteristiquesAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          CaracteristiqueData
                                        ).map(([key, value], index) => (
                                          <div
                                            key={index}
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: [
                                                "Document type",
                                                "Nom du modèle",
                                                "Actif",
                                              ].includes(key)
                                                ? "white"
                                                : "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: [
                                                "Document type",
                                                "Nom du modèle",
                                                "Actif",
                                              ].includes(key)
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (
                                                [
                                                  "Document type",
                                                  "Nom du modèle",
                                                  "Actif",
                                                ].includes(key)
                                              ) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffe6e6";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (
                                                [
                                                  "Document type",
                                                  "Nom du modèle",
                                                  "Actif",
                                                ].includes(key)
                                              ) {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#dc3545";
                                              } else {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            {key === "Document type" ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>

                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedType?.label ==
                                                        null
                                                          ? null
                                                          : selectedType
                                                      }
                                                      onChange={
                                                        handleTypeChange
                                                      }
                                                      options={renderTypeOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedType === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                    {selectedType === null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Document type ne peut
                                                        pas être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : key === "Original" ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedOriginal?.label ==
                                                        null
                                                          ? null
                                                          : selectedOriginal
                                                      }
                                                      onChange={
                                                        handleOriginalChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : key === "Nom du modèle" ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>

                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedNomMod}
                                                      required
                                                      onChange={
                                                        handleNomModChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",

                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedNomMod === "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Nom du modèle ne peut
                                                        pas être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : key === "Actif" ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>

                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedActif?.label ==
                                                        null
                                                          ? null
                                                          : selectedActif
                                                      }
                                                      onChange={
                                                        handleActifChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedActif === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                    {selectedActif === null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Actif ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : key ===
                                                "A transmettre au fisc" &&
                                              showData == true ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedFisc?.label ==
                                                        null
                                                          ? null
                                                          : selectedFisc
                                                      }
                                                      onChange={
                                                        handleFiscChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : key ===
                                              "Transmission API CGP" ? (
                                              <>
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedTransmissionAPI?.label ==
                                                        null
                                                          ? null
                                                          : selectedTransmissionAPI
                                                      }
                                                      onChange={
                                                        handleTransmissionAPIChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : null}
                                          </div>
                                        ))}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleFiltresCumulAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Filtres / Cumul
                                      </span>
                                    </div>
                                    {isFiltresCumulAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isFiltresCumulAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(FiltresData).map(
                                          ([key, value], index) => (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor:
                                                  key ===
                                                  "Cumul par investisseur"
                                                    ? "white"
                                                    : "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  key ===
                                                  "Cumul par investisseur"
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                if (
                                                  key ===
                                                  "Cumul par investisseur"
                                                ) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (
                                                  key ===
                                                  "Cumul par investisseur"
                                                ) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }
                                              }}
                                            >
                                              {key ===
                                              "Balises non nulle pour impression" ? (
                                                <>
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium me-1"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <i
                                                          className="bx bx-info-circle ms-1"
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#007bff",
                                                            fontSize: "14px",
                                                          }}
                                                          id="Balise"
                                                          onMouseEnter={
                                                            toggleTooltip2
                                                          }
                                                          onMouseLeave={
                                                            toggleTooltip2
                                                          }
                                                        />
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>

                                                        <Tooltip
                                                          placement="top"
                                                          isOpen={tooltipOpen2}
                                                          target="Balise"
                                                          toggle={
                                                            toggleTooltip2
                                                          }
                                                        >
                                                          {
                                                            modelData
                                                              ?.detail_publipostage
                                                              ?.helpers[
                                                              "Balises non nulle pour impression"
                                                            ]
                                                          }
                                                        </Tooltip>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={8}
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedBalise}
                                                        required
                                                        onChange={
                                                          handleBaliseChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              ) : key === "Catégorie de PME" ? (
                                                <>
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedCategorie?.label ==
                                                          null
                                                            ? null
                                                            : selectedCategorie
                                                        }
                                                        onChange={
                                                          handleCategorieChange
                                                        }
                                                        options={renderCategorieOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner..."
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              ) : key ===
                                                "Cumul par investisseur" ? (
                                                <>
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>

                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedCumul?.label ==
                                                          null
                                                            ? null
                                                            : selectedCumul
                                                        }
                                                        onChange={
                                                          handleCumulChange
                                                        }
                                                        options={renderOuiNonOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedCumul === null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner..."
                                                      />
                                                      {selectedCumul ===
                                                        null && (
                                                        <div
                                                          className="small mt-1"
                                                          style={{
                                                            color: "red",
                                                            fontSize: "0.75rem",
                                                          }}
                                                        >
                                                          Cumul par investisseur
                                                          ne peut pas être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </>
                                              ) : null}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                <Row>
                                  <Col sm="12">
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleCommentairesAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Commentaires
                                          </span>
                                        </div>
                                        {isCommentairesAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isCommentairesAccordionOpen}
                                      >
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {Object.entries(
                                              CommentaireData
                                            ).map(([key, value], index) => (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor:
                                                    key === "Commentaires"
                                                      ? "white"
                                                      : "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    key === "Commentaires"
                                                      ? "3px solid #dc3545"
                                                      : "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (key === "Commentaires") {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  if (key === "Commentaires") {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }
                                                }}
                                              >
                                                {key === "Commentaires" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                              display:
                                                                "inline-block",
                                                              width: "11em",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>

                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            selectedCommentaire
                                                          }
                                                          required
                                                          onChange={
                                                            handleCommentaireChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",

                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                        {selectedCommentaire ===
                                                          "" && (
                                                          <div
                                                            className="small mt-1"
                                                            style={{
                                                              color: "red",
                                                              fontSize:
                                                                "0.75rem",
                                                            }}
                                                          >
                                                            Commentaires ne peut
                                                            pas être vide
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : null}
                                              </div>
                                            ))}
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={togglePresentationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Présentation / sortie
                                      </span>
                                    </div>
                                    {isPresentationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isPresentationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(PresentationData).map(
                                          ([key, value], index) => {
                                            const champsObligatoires = [
                                              "Nom du fichier global",
                                              "Nom des fichiers individuels",
                                              "Marge haut (cm)",
                                              "Marge bas (cm)",
                                              "Marge côtés (cm)",
                                              "Orientation",
                                              "Un fichier par occurence",
                                              "Hauteur de ligne (em)",
                                            ];
                                            const estObligatoire =
                                              champsObligatoires.includes(key);

                                            return (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft: estObligatoire
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (estObligatoire) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  if (estObligatoire) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }
                                                }}
                                              >
                                                {key ===
                                                  "Nom du fichier global" ||
                                                key === "Marge haut (cm)" ||
                                                key === "Marge bas (cm)" ||
                                                key === "Marge côtés (cm)" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>

                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            key ===
                                                            "Nom du fichier global"
                                                              ? selectedNomGlobal
                                                              : key ===
                                                                "Marge haut (cm)"
                                                              ? selectedMargeHaut
                                                              : key ===
                                                                "Marge bas (cm)"
                                                              ? selectedMargeBas
                                                              : selectedMargeCote
                                                          }
                                                          required
                                                          onChange={
                                                            key ===
                                                            "Nom du fichier global"
                                                              ? handleNomGlobalChange
                                                              : key ===
                                                                "Marge haut (cm)"
                                                              ? handleMargeHautChange
                                                              : key ===
                                                                "Marge bas (cm)"
                                                              ? handleMargeBasChange
                                                              : handleMargeCoteChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",

                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                        {((key ===
                                                          "Nom du fichier global" &&
                                                          selectedNomGlobal ===
                                                            "") ||
                                                          (key ===
                                                            "Marge haut (cm)" &&
                                                            selectedMargeHaut ===
                                                              "") ||
                                                          (key ===
                                                            "Marge bas (cm)" &&
                                                            selectedMargeBas ===
                                                              "") ||
                                                          (key ===
                                                            "Marge côtés (cm)" &&
                                                            selectedMargeCote ===
                                                              "")) && (
                                                          <div
                                                            className="small mt-1"
                                                            style={{
                                                              color: "red",
                                                              fontSize:
                                                                "0.75rem",
                                                            }}
                                                          >
                                                            {key} ne peut pas
                                                            être vide
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : key ===
                                                  "Nom des fichiers individuels" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium me-1"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>
                                                          <i
                                                            className="bx bx-info-circle ms-1"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#007bff",
                                                              fontSize: "14px",
                                                            }}
                                                            id="nomFichierIndivInfoTooltip"
                                                            onMouseEnter={
                                                              toggleTooltip
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={tooltipOpen}
                                                            target="nomFichierIndivInfoTooltip"
                                                            toggle={
                                                              toggleTooltip
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Nom du fichier"
                                                              ]
                                                            }
                                                          </Tooltip>

                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            selectedNomIndividuel
                                                          }
                                                          required
                                                          onChange={
                                                            handleNomIndividuelChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",

                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                        {selectedNomIndividuel ===
                                                          "" && (
                                                          <div
                                                            className="small mt-1"
                                                            style={{
                                                              color: "red",
                                                              fontSize:
                                                                "0.75rem",
                                                            }}
                                                          >
                                                            Nom des fichiers
                                                            individuels ne peut
                                                            pas être vide
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : key === "Largeur (px)" ||
                                                  key ===
                                                    "Espace entre le footer/header et le corps (mm)" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            key ===
                                                            "Largeur (px)"
                                                              ? selectedLargeur
                                                              : selectedHauteurPied
                                                          }
                                                          required
                                                          onChange={
                                                            key ===
                                                            "Largeur (px)"
                                                              ? handleLargeurChange
                                                              : handleHauteurPiedChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",

                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : key === "Orientation" ||
                                                  key ===
                                                    "Un fichier par occurence" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>

                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col xs={12} md={8}>
                                                        <Select
                                                          value={
                                                            key ===
                                                            "Orientation"
                                                              ? selectedOrientation
                                                              : selectedFichierParOccurence
                                                          }
                                                          onChange={
                                                            key ===
                                                            "Orientation"
                                                              ? handleOrientationChange
                                                              : handleFichierParOccurenceChange
                                                          }
                                                          options={
                                                            key ===
                                                            "Orientation"
                                                              ? renderOrientationOptions()
                                                              : renderOuiNonOptions()
                                                          }
                                                          isClearable={true}
                                                          classNamePrefix="select2-selection"
                                                          styles={styles(
                                                            key ===
                                                              "Orientation"
                                                              ? selectedOrientation ===
                                                                  null
                                                              : selectedFichierParOccurence ===
                                                                  null
                                                          )}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          placeholder="Sélectionner..."
                                                        />
                                                        {((key ===
                                                          "Orientation" &&
                                                          selectedOrientation ===
                                                            null) ||
                                                          (key ===
                                                            "Un fichier par occurence" &&
                                                            selectedFichierParOccurence ===
                                                              null)) && (
                                                          <div
                                                            className="small mt-1"
                                                            style={{
                                                              color: "red",
                                                              fontSize:
                                                                "0.75rem",
                                                            }}
                                                          >
                                                            {key} ne peut pas
                                                            être vide
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : key ===
                                                  "Hauteur de ligne (em)" ? (
                                                  <>
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium me-1"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>
                                                          <i
                                                            className="bx bx-info-circle ms-1"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#007bff",
                                                              fontSize: "14px",
                                                            }}
                                                            id="HauteurLigne"
                                                            onMouseEnter={
                                                              toggleTooltip4
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip4
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={
                                                              tooltipOpen4
                                                            }
                                                            target="HauteurLigne"
                                                            toggle={
                                                              toggleTooltip4
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Hauteur de ligne (em)"
                                                              ]
                                                            }
                                                          </Tooltip>
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col
                                                        xs={12}
                                                        md={8}
                                                        style={{
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <input
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          value={
                                                            selectedHauteurLigne
                                                          }
                                                          required
                                                          onChange={
                                                            handleHauteurLigneChange
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",

                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            height: "32px",
                                                          }}
                                                        />
                                                        <FiEdit3
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                        {selectedHauteurLigne ===
                                                          "" && (
                                                          <div
                                                            className="small mt-1"
                                                            style={{
                                                              color: "red",
                                                              fontSize:
                                                                "0.75rem",
                                                            }}
                                                          >
                                                            Hauteur de ligne ne
                                                            peut pas être vide
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </>
                                                ) : null}
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                {Object.keys(ChampsImpressionData).length >
                                0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden mb-4"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={
                                            toggleChampsImpressionAccordion
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Champs d'impression
                                            </span>
                                          </div>
                                          {isChampsImpressionAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        <Collapse
                                          isOpen={
                                            isChampsImpressionAccordionOpen
                                          }
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {Object.entries(
                                                ChampsImpressionData
                                              ).map(([key, value], index) => (
                                                <div
                                                  key={index}
                                                  className="field-item px-2 py-1 mb-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",

                                                    position: "relative",
                                                    marginBottom: "1px",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  {key === "Champ 1" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium me-1"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <i
                                                              className="bx bx-info-circle ms-1"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color:
                                                                  "#007bff",
                                                                fontSize:
                                                                  "14px",
                                                              }}
                                                              id="champ1ToolTip"
                                                              onMouseEnter={
                                                                toggleTooltip1
                                                              }
                                                              onMouseLeave={
                                                                toggleTooltip1
                                                              }
                                                            />
                                                            <Tooltip
                                                              placement="top"
                                                              isOpen={
                                                                tooltipOpen1
                                                              }
                                                              target="champ1ToolTip"
                                                              toggle={
                                                                toggleTooltip1
                                                              }
                                                            >
                                                              {
                                                                modelData
                                                                  ?.detail_publipostage
                                                                  ?.helpers[
                                                                  "Champ 1"
                                                                ]
                                                              }
                                                            </Tooltip>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps1
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps1Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : key === "Champ 2" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps2
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps2Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : key === "Champ 3" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps3
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps3Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : key === "Champ 4" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps4
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps4Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : key === "Champ 5" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps5
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps5Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : key === "Champ 6" ? (
                                                    <>
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                                display:
                                                                  "inline-block",
                                                                width: "11em",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <input
                                                            className="form-control form-control-sm shadow-sm border-0"
                                                            value={
                                                              selectedChamps6
                                                            }
                                                            required
                                                            onChange={
                                                              handleChamps6Change
                                                            }
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              backgroundColor:
                                                                "#f8f9fa",
                                                              borderRadius:
                                                                "6px",
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              height: "32px",
                                                            }}
                                                          />
                                                          <FiEdit3
                                                            size={12}
                                                            className="position-absolute text-muted"
                                                            style={{
                                                              right: "8px",
                                                              top: "50%",
                                                              transform:
                                                                "translateY(-50%)",
                                                              pointerEvents:
                                                                "none",
                                                              opacity: 0.9,
                                                            }}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  ) : null}
                                                </div>
                                              ))}
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                                {Object.keys(ImagesData).length > 0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden mb-4"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={toggleImagesAccordion}
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Images
                                            </span>
                                          </div>
                                          {isImagesAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        <Collapse
                                          isOpen={isImagesAccordionOpen}
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {Object.entries(ImagesData).map(
                                                ([key, value], index) => (
                                                  <div
                                                    key={index}
                                                    className="field-item px-2 py-1 mb-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid transparent",
                                                      position: "relative",
                                                      marginBottom: "1px",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#e3f2fd";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#007bff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "transparent";
                                                    }}
                                                  >
                                                    {key === "Image 1" ? (
                                                      <>
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium me-1"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "11em",
                                                                }}
                                                              >
                                                                {key}
                                                              </span>
                                                              <i
                                                                className="bx bx-info-circle ms-1"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  color:
                                                                    "#007bff",
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                                id="Image"
                                                                onMouseEnter={
                                                                  toggleTooltip3
                                                                }
                                                                onMouseLeave={
                                                                  toggleTooltip3
                                                                }
                                                              />
                                                              <Tooltip
                                                                placement="top"
                                                                isOpen={
                                                                  tooltipOpen3
                                                                }
                                                                target="Image"
                                                                toggle={
                                                                  toggleTooltip3
                                                                }
                                                              >
                                                                {
                                                                  modelData
                                                                    ?.detail_publipostage
                                                                    ?.helpers[
                                                                    "Image 1"
                                                                  ]
                                                                }
                                                              </Tooltip>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col xs={12} md={8}>
                                                            {selectedImage1 !=
                                                              null && (
                                                              <a
                                                                href={
                                                                  selectedImage1
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-block mb-2 small text-primary"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              >
                                                                <i className="bx bx-image me-1"></i>
                                                                Voir l'image
                                                              </a>
                                                            )}
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              type="file"
                                                              required
                                                              onChange={
                                                                handleImage1Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </>
                                                    ) : key === "Image 2" ? (
                                                      <>
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "11em",
                                                                }}
                                                              >
                                                                {key}
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col xs={12} md={8}>
                                                            {selectedImage2 !=
                                                              null && (
                                                              <a
                                                                href={
                                                                  selectedImage2
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-block mb-2 small text-primary"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              >
                                                                <i className="bx bx-image me-1"></i>
                                                                Voir l'image
                                                              </a>
                                                            )}
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              type="file"
                                                              onChange={
                                                                handleImage2Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </>
                                                    ) : key === "Image 3" ? (
                                                      <>
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "11em",
                                                                }}
                                                              >
                                                                {key}
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col xs={12} md={8}>
                                                            {selectedImage3 !=
                                                              null && (
                                                              <a
                                                                href={
                                                                  selectedImage3
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-block mb-2 small text-primary"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              >
                                                                <i className="bx bx-image me-1"></i>
                                                                Voir l'image
                                                              </a>
                                                            )}
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              type="file"
                                                              required
                                                              onChange={
                                                                handleImage3Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </>
                                                    ) : key === "Image 4" ? (
                                                      <>
                                                        <Row className="align-items-center g-1">
                                                          <Col xs={12} md={4}>
                                                            <div className="d-flex align-items-center small text-muted">
                                                              <span
                                                                className="fw-medium"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  letterSpacing:
                                                                    "0.2px",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "11em",
                                                                }}
                                                              >
                                                                {key}
                                                              </span>
                                                              <span className="ms-1 text-primary">
                                                                :
                                                              </span>
                                                            </div>
                                                          </Col>
                                                          <Col xs={12} md={8}>
                                                            {selectedImage4 !=
                                                              null && (
                                                              <a
                                                                href={
                                                                  selectedImage4
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-block mb-2 small text-primary"
                                                                style={{
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              >
                                                                <i className="bx bx-image me-1"></i>
                                                                Voir l'image
                                                              </a>
                                                            )}
                                                            <input
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              type="file"
                                                              required
                                                              onChange={
                                                                handleImage4Change
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                          </Col>
                                                        </Row>
                                                      </>
                                                    ) : null}
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                              </Col>
                            </Row>
                            <Row>
                              <Row>
                                <Col sm="12">
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleContenuAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Contenu
                                        </span>
                                      </div>
                                      {isContenuAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse isOpen={isContenuAccordionOpen}>
                                      <CardBody className="p-3">
                                        {/* Liste des balises */}
                                        <div
                                          className="mb-3 px-2 py-2"
                                          style={{
                                            backgroundColor: "#f8f9fa",
                                            borderRadius: "8px",
                                          }}
                                        >
                                          <Row className="align-items-center">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Liste des balises
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Button
                                                color="primary"
                                                size="sm"
                                                onClick={handleOffcanvasToggle}
                                                className="shadow-sm"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                }}
                                              >
                                                <i className="bx bx-list-ul me-1"></i>
                                                Liste
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Éditeur TinyMCE */}
                                        <div
                                          className="mb-3"
                                          style={{ zIndex: 100000 }}
                                        >
                                          <Editor
                                            onEditorChange={(content) => {
                                              setContent(content);
                                            }}
                                            apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                            onInit={(evt, editor) =>
                                              (editorRef.current = editor)
                                            }
                                            value={selectedContent}
                                            init={{
                                              height: 700,
                                              menubar: true,
                                              plugins: [
                                                "advlist",
                                                "autolink",
                                                "lists",
                                                "link",
                                                "image",
                                                "charmap",
                                                "preview",
                                                "anchor",
                                                "searchreplace",
                                                "visualblocks",
                                                "code",
                                                "fullscreen",
                                                "insertdatetime",
                                                "media",
                                                "table",
                                                "code",
                                                "help",
                                                "wordcount",
                                                "autosave",
                                              ],
                                              toolbar:
                                                "undo redo | blocks | " +
                                                "bold italic forecolor | alignleft aligncenter " +
                                                "alignright alignjustify | bullist numlist outdent indent | " +
                                                "removeformat | help",
                                              content_style:
                                                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                            }}
                                          />
                                        </div>

                                        {/* Header et Footer */}
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            modelData?.detail_publipostage?.[
                                              "Contenu"
                                            ] || {}
                                          ).map(([key, value], index) => (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              {key === "Header" ? (
                                                <>
                                                  <Row className="align-items-start g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted pt-1">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <textarea
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedHeader}
                                                        required
                                                        onChange={
                                                          handleHeaderChange
                                                        }
                                                        rows={3}
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "8px",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              ) : key === "Footer" ? (
                                                <>
                                                  <Row className="align-items-start g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted pt-1">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <textarea
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedFooter}
                                                        required
                                                        onChange={
                                                          handleFooterChange
                                                        }
                                                        rows={3}
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "8px",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              ) : null}
                                            </div>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                </Col>
                              </Row>
                              <Col sm="12">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleSignatureAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Signature électronique
                                      </span>
                                      <i
                                        className="bx bx-info-circle ms-2"
                                        style={{
                                          cursor: "pointer",
                                          color: "white",
                                          fontSize: "15px",
                                        }}
                                        id="Signataires"
                                        onMouseEnter={toggleTooltip8}
                                        onMouseLeave={toggleTooltip8}
                                      />
                                      <Tooltip
                                        placement="top"
                                        isOpen={tooltipOpen8}
                                        target="Signataires"
                                        toggle={toggleTooltip8}
                                      >
                                        {
                                          modelData?.detail_publipostage
                                            ?.helpers["Signataires"]
                                        }
                                      </Tooltip>
                                    </div>
                                    {isSignatureAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isSignatureAccordionOpen}>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                {modelData?.detail_publipostage?.[
                                                  "Signature électronique"
                                                ]?.Signataires.header.map(
                                                  (columnName, index) => (
                                                    <th
                                                      className=""
                                                      style={{
                                                        background: "#ebd826",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                      }}
                                                      key={index}
                                                    >
                                                      {columnName}
                                                      {columnName ===
                                                      "Page signature" ? (
                                                        <>
                                                          <i
                                                            className="bx bx-info-circle ms-1"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "white",
                                                              fontSize: "14px",
                                                            }}
                                                            id="Page-Signature"
                                                            onMouseEnter={
                                                              toggleTooltip5
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip5
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={
                                                              tooltipOpen5
                                                            }
                                                            target="Page-Signature"
                                                            toggle={
                                                              toggleTooltip5
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Page signature"
                                                              ]
                                                            }
                                                          </Tooltip>
                                                        </>
                                                      ) : columnName ===
                                                        "Position signature" ? (
                                                        <>
                                                          <i
                                                            className="bx bx-info-circle ms-1"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "white",
                                                              fontSize: "14px",
                                                            }}
                                                            id="Position-Signature"
                                                            onMouseEnter={
                                                              toggleTooltip6
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip6
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={
                                                              tooltipOpen6
                                                            }
                                                            target="Position-Signature"
                                                            toggle={
                                                              toggleTooltip6
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Position signature"
                                                              ]
                                                            }
                                                          </Tooltip>
                                                        </>
                                                      ) : columnName ===
                                                        "Signataire" ? (
                                                        <>
                                                          <i
                                                            className="bx bx-info-circle ms-1"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "white",
                                                              fontSize: "14px",
                                                            }}
                                                            id="Signataire"
                                                            onMouseEnter={
                                                              toggleTooltip7
                                                            }
                                                            onMouseLeave={
                                                              toggleTooltip7
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="top"
                                                            isOpen={
                                                              tooltipOpen7
                                                            }
                                                            target="Signataire"
                                                            toggle={
                                                              toggleTooltip7
                                                            }
                                                          >
                                                            {
                                                              modelData
                                                                ?.detail_publipostage
                                                                ?.helpers[
                                                                "Signataires"
                                                              ]
                                                            }
                                                          </Tooltip>
                                                        </>
                                                      ) : null}
                                                    </th>
                                                  )
                                                )}
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#ebd826",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                  key="Del"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formSignature?.map((rowData) => (
                                                <tr key={rowData.index}>
                                                  {Object.entries(rowData).map(
                                                    ([key, value]) =>
                                                      key !== "id" &&
                                                      key !== "index" ? (
                                                        <td
                                                          className={key}
                                                          key={key}
                                                        >
                                                          {key ===
                                                            "page_signature" ||
                                                          key ===
                                                            "position_signature" ||
                                                          key ===
                                                            "signataire" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              value={value}
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <span>{value}</span>
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          className="d-none"
                                                          key={key}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            value={value}
                                                          />
                                                        </td>
                                                      )
                                                  )}
                                                  <td>
                                                    <i
                                                      className="bx bx-trash"
                                                      style={{
                                                        fontSize: "20px",
                                                        paddingTop: "5px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        onDeleteFormSignature(
                                                          rowData.index
                                                        )
                                                      }
                                                    ></i>
                                                  </td>
                                                </tr>
                                              ))}
                                              <tr>
                                                <td colSpan="9">
                                                  <input
                                                    type="button"
                                                    style={{
                                                      background: "#555B21",
                                                      color: "white",
                                                      paddingTop: "5px",
                                                      paddingBottom: "5px",
                                                    }}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={onAddFormSignature}
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditModel;
